import {IClubForm} from 'packages/common-types/base-types';
import {useFormContext} from 'react-hook-form';
import {memo} from 'react';
import {TextField} from '@material-ui/core';

const FormNameClub = memo(() => {
  const {register} = useFormContext<IClubForm>();
  return (
    <>
      <TextField
        autoFocus
        margin="dense"
        autoComplete="none"
        placeholder="Escribe el nombre del club que quieres añadir"
        variant="outlined"
        name="name"
        id="name"
        inputRef={register()}
        label="Nombre del club"
        type="text"
        fullWidth
      />
    </>
  );
});

FormNameClub.displayName = 'FormClubName';

export default FormNameClub;
